import { ROUTES } from "@/shared/model/routes";

type RouteResult = string | null;

// ABOUTME: Determines navigation routes for WebSocket notifications
// ABOUTME: Maps notifiable_type to routes with proper id/query parameter handling

/**
 * Get navigation route for notification based on notifiable_type and notifiable_id.
 *
 * Routes with path params (/:id): products, stores, store/products, tickets
 * Routes with query params (?query=id): purchases, sales, disputes, withdrawals, deposits, reviews
 */
export function getNotificationRoute(
  notifiableType: string | null,
  notifiableId: string | null,
): RouteResult {
  if (!notifiableType || !notifiableId) {
    return null;
  }

  switch (notifiableType) {
    // Path-based routes (/:id)
    case "Product":
      return ROUTES.PRODUCT.replace(":id", notifiableId);
    case "Store":
      return ROUTES.STORE.replace(":id", notifiableId);
    case "StoreProduct":
      return ROUTES.STORE_PRODUCT.replace(":id", notifiableId);
    case "Ticket":
      return `/tickets/${notifiableId}`;

    // Query-based routes (?query=id)
    case "Purchase":
      return `${ROUTES.PURCHASES}?query=${notifiableId}`;
    case "Sale":
      return `${ROUTES.SALES}?query=${notifiableId}`;
    case "Dispute":
      return `${ROUTES.DISPUTES}?query=${notifiableId}`;
    case "SellerDispute":
      return `${ROUTES.STORE_DISPUTES}?query=${notifiableId}`;
    case "Withdrawal":
      return `${ROUTES.WITHDRAWALS}?query=${notifiableId}`;
    case "DepositRequest":
      return `${ROUTES.DEPOSITS}?query=${notifiableId}`;
    case "Review":
      return `${ROUTES.STORE_REVIEWS}?query=${notifiableId}`;

    default:
      return null;
  }
}
